import useFlag, { FLAGS } from '@rover/shared/js/hooks/useFlag';

type UseSimplifiedFiltersReturn = {
  isActive: boolean;
};

/**
 * Hook to check the simplified_mobile_search_filters_v4 experiment.
 * This experiment controls whether to show the redesigned simplified filters in the
 * mobile search experience. Returns the isActive flag (true for the treatment group).
 */
export const useSimplifiedFilters = (): UseSimplifiedFiltersReturn => {
  const isActive = useFlag(FLAGS.IS_V4_SIMPLIFIED_MOBILE_SEARCH_FILTERS);

  return { isActive };
};
